var render, staticRenderFns
import script from "./PopupScopeBase.vue?vue&type=script&lang=ts&"
export * from "./PopupScopeBase.vue?vue&type=script&lang=ts&"
import style0 from "./PopupScopeBase.vue?vue&type=style&index=0&id=0232d036&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0232d036",
  null
  
)

export default component.exports